/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { ReactNode } from 'react';
import { jsx, css } from '@compiled/react';
import { token } from '@atlaskit/tokens';

const titleBoxWrapperStyles = css({
	backgroundColor: token('elevation.surface'),
	cursor: 'inherit',
	pointerEvents: 'none',
	font: token('font.body.small'),
	paddingTop: token('space.100'),
	paddingRight: token('space.100'),
	paddingBottom: token('space.100'),
	paddingLeft: token('space.100'),
});

export const TitleBoxWrapper = ({ children }: { children: ReactNode }) => {
	return (
		<div
			id="titleBoxWrapper"
			data-testid="issue-view-base.content.attachment.grid-view.ui.components.media-card.title-box"
			css={[titleBoxWrapperStyles]}
		>
			{children}
		</div>
	);
};

const infoStyles = css({
	whiteSpace: 'nowrap',
	overflow: 'hidden',
});

export const TitleBoxHeader = ({ children }: { children: ReactNode }) => {
	return (
		<div
			id="titleBoxHeader"
			data-testid="issue-view-base.content.attachment.grid-view.ui.components.media-card.title-box-header"
			css={[infoStyles]}
		>
			{children}
		</div>
	);
};

const titleBoxFooterStyle = css({
	height: '18px',
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	color: token('color.text.subtlest'),
});

export const TitleBoxFooter = ({ children }: { children: ReactNode }) => {
	return (
		<div
			id="titleBoxFooter"
			data-testid="issue-view-base.content.attachment.grid-view.ui.components.media-card.title-box-footer"
			css={[infoStyles, titleBoxFooterStyle]}
		>
			{children}
		</div>
	);
};

const TitleBox = { Wrapper: TitleBoxWrapper, Header: TitleBoxHeader, Footer: TitleBoxFooter };
export default TitleBox;
